var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 5,
    fill: "#FFF",
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37390_286704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0625 14.75C22.6937 14.7591 23.5772 14.8314 24.1535 15.4077C24.8125 16.0667 24.8125 17.1274 24.8125 19.2487V19.9987C24.8125 22.12 24.8125 23.1807 24.1535 23.8397C23.4944 24.4987 22.4338 24.4987 20.3125 24.4987H14.3125C12.1912 24.4987 11.1305 24.4987 10.4715 23.8397C9.8125 23.1807 9.8125 22.12 9.8125 19.9987V19.2487C9.8125 17.1274 9.8125 16.0667 10.4715 15.4077C11.0478 14.8314 11.9312 14.7591 13.5625 14.75",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3125 19.25V9.5M17.3125 9.5L19.5625 12.125M17.3125 9.5L15.0625 12.125",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37390_286704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadArrowIcon);
export default __webpack_public_path__ + "static/media/UploadArrowIcon.dcf5053d72e79a300b75a0c75121d996.svg";
export { ForwardRef as ReactComponent };